export default {
  presenter: 'zapletal',
  title: 'Automatizace instalace Linuxu přes Foreman',
  subtitle: 'mírně pokročilí',
  text: `
Dneska mnoho lidí používá virtualizaci nebo cloud, nový stroj máte lusknutím prstu. My půjdeme
o úroveň níž. Co když si chcete postavit takový cloud nebo cluster. Jak instalovat na holé
železo? Odpověď je často v automatizaci instalátoru OS, skriptování a config managementu.  
Open source projekt The Foreman (https://theforeman.org) poskytuje bohaté možnosti v oblasti
automatizace instalací Linuxu pomocí bootování ze sítě (PXE). Ve workshopu si nainstalujeme
Foreman do virtuálky, nastavíme potřebné parametry pro management PXE ve virtuální síti a
provedeme automatizovanou instalaci CentOS a Debian.  
Workshop bude určen pro naprosté začátečníky v oblasti PXE bootingu, předpokládá se základní
znalost sítí, Linuxu a práce s virtualizací. Potřebný hardware: 8+ GB RAM, Linux s libvirtem
nebo OS s VirtualBox. Vytvoříme si virtuální síť a dva VM.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/zapletal-foreman.js